<template>
	<b-modal id="modal-reinicioControl" cancel-title="Cerrar" :ok-disabled="true">
		<template v-slot:modal-title>
			<label>Reinicio Control</label>
		</template>
		<b-alert show variant="warning">
			Desmarca al alumno que no desees que este en la lista.
			<br>
			(<small><b><span>Solo se realiza el reinicio a alumnos con nota inferior a la minima requerida.</span></b></small>)
		</b-alert>
		<b-form-group>
			<label> #{{ infoCurso.id }} {{ infoCurso.nombre }} </label>
		</b-form-group>
		<div
			style="overflow-y: scroll; height: 400px;"
		>
			<table class="table table-striped">
				<tbody>
					<tr v-for="alumno in listadoAlumnos" :key="alumno.idAlumno">
						<td style="text-align: initial;">
							<b-form-checkbox
								v-model="alumno.estado"
								size="sm"
							>
								{{ alumno.nombre }}-{{alumno.idAlumno}}
							</b-form-checkbox>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<small>Listado de alumnos disponibles.</small>
        <b-form-checkbox @change="changeValorAlumno($event)" size="sm">{{tituloMarcarDesmarcar}}</b-form-checkbox>
		 <div class="contenedorBotonReiniciar">
			 <button type="button" class="btn btn-primary botonReiniciar" @click="submitModalMarcados()">Reiniciar</button>
		 </div>
		<toastComponent ref="toastComponent" />
	</b-modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toastComponent from "@/components/toastComponent.vue";
export default {
	components: {
      toastComponent
	},
	data() {
		return {
			infoCurso: {},
			checked2: true,
			listadoAlumnos: {},
			listadoAlumnosApi:[],
			tituloMarcarDesmarcar:"Desmarcar Todos",
		};
	},
	computed: {
		...mapState("curso", ["jsonCurso"]),
	},
	methods: {
		submitModalMarcados(){
			if(this.listadoAlumnosApi != null){
			   //filtrar del listado a los alumnos que el estado sea true y ademas el promedio sea !=  de '-' y menor que 4
			   let filtroAlumnosRecalcular = this.listadoAlumnos.filter((alumno)=>{
				  if(alumno.estado && alumno.promedioFinal != '-' && alumno.promedioFinal < 4){
					  return alumno;  
				  }else{
					  return null
				  } 
			   });
	
	
			   if(filtroAlumnosRecalcular.length > 0){
				   let idEvaluacion = this.infoCurso.id;
				   filtroAlumnosRecalcular.map(async (al)=>{
					 //llamar la api para cada alumno que venga en el filtro para que se realize el reinicio solo si estan seleccionados
						al.idEvaluacion = idEvaluacion;
						const form = al;
						let result = await this.axios.post('api/resetNotaAlumno',form);
				   });
				  //mostrar mensaje de cuantos se actualizaron y cuantos eran
				   this.$refs.toastComponent.makeToast({
					msg: `Se ha reiniciado la nota para ${filtroAlumnosRecalcular.length} alumnos de un total de ${filtroAlumnosRecalcular.length} alumnos seleccionados`,
					title: "Estado Nota",
					variant: "success",
				   });
			   }else{
				   this.$refs.toastComponent.makeToast({
					msg: `No se ha reiniciado la nota para ningun alumno por que todos cumplen con la nota minima requerida. `,
					title: "Estado Nota",
					variant: "danger",
				   });
			   }
		   }else{
			   this.$refs.toastComponent.makeToast({
					msg: `No existen alumnos seleccionados`,
					title: "Estado Nota",
					variant: "danger",
			   });
		   }


		},
		changeValorAlumno(event){
			if(this.listadoAlumnosApi != null){
				this.listadoAlumnos = this.listadoAlumnosApi.map(elem => {
						elem.idAlumno;
						elem.nombre;
						elem.estado = !elem.estado;
						return elem;
				});
				if(event){
				  this.tituloMarcarDesmarcar = "Marcar Todos";
				}else{
				  this.tituloMarcarDesmarcar = "Desmarcar Todos";
				}
			}
		},
		async getInfo(data) {
			//llamar la api para traer los alumnos
			let listadoAlumnosApi = await this.axios.get("api/getAlumnosCursoById/" + this.jsonCurso.idCurso);
			this.listadoAlumnosApi = listadoAlumnosApi.data.alumnoLista;

			this.infoCurso = data;
			if(this.listadoAlumnosApi != null){
				this.listadoAlumnos = this.listadoAlumnosApi.map(elem => {
					elem.idAlumno;
					elem.nombre;
					elem.estado = true;
					return elem;
				});
			}
		}
	}
};
</script>
<style>
 .botonReiniciar{
	 margin-top: 15px;
	 width: 150px;
 }
 .contenedorBotonReiniciar{
	 text-align: center;
 }
 #modal-reinicioControl___BV_modal_footer_ > button.btn.btn-primary.disabled{
	 display: none;
 }
</style>
